module.exports = __webpack_public_path__ + "static/media/dashboard-check-box-icon.72b58078.svg";